<template>
  <q-tr class="row-presupuesto">
    <q-td key="Fecha" :props="dataItem">{{
      dataItem.row.Fecha | formato_fecha
    }}</q-td>

    <q-td
      key="Nombre"
      class="list_titulo_listado_textos_negrita"
      :props="dataItem"
    >
      {{ sliceActuacion }}
      <q-tooltip>{{ dataItem.row.Nombre }}</q-tooltip>
    </q-td>
    <q-td key="Empresa" class="list_titulo_listado_textos" :props="dataItem">
      {{ sliceEmpresa }}
      <q-tooltip>{{ primera_mayuscula(dataItem.row.Empresa) }}</q-tooltip>
    </q-td>
    <q-td key="Provincia" class="list_titulo_listado_textos" :props="dataItem">
      {{ sliceProvincia }}
      <q-tooltip>{{ dataItem.row.Provincia }}</q-tooltip>
    </q-td>
    <q-td key="Municipio" class="list_titulo_listado_textos" :props="dataItem">
      {{ sliceMunicipio }}
      <q-tooltip>{{ dataItem.row.Municipio }}</q-tooltip>
    </q-td>
    <q-td
      key="Estado"
      :style="cambiar_color(dataItem.row.Estado)"
      :props="dataItem"
      >{{ dataItem.row.Estado }}</q-td
    >
    <q-td key="Servicio" class="list_titulo_listado_textos" :props="dataItem">{{
      dataItem.row.Servicio
    }}</q-td>
    <q-td
      key="Tecnologia"
      class="list_titulo_listado_textos_negrita"
      :props="dataItem"
      >{{ dataItem.row.Tecnologia }}</q-td
    >
    <q-td
      key="CosteTcz"
      class="list_titulo_listado_presupuestos"
      :props="dataItem"
      >{{ formato_numero(dataItem.row.CosteTcz) }} €</q-td
    >
    <q-td
      key="CosteTsz"
      class="list_titulo_listado_presupuestos"
      :props="dataItem"
      >{{ formato_numero(dataItem.row.CosteTsz) }} €</q-td
    >
    <q-td
      key="BeneficioCoste"
      class="list_titulo_listado_presupuestos_negrita"
      :props="dataItem"
      >{{ formato_numero(dataItem.row.BeneficioCoste) }}%</q-td
    >
    <q-td
      key="BeneficioTiempo"
      class="list_titulo_listado_presupuestos_negrita"
      :props="dataItem"
      >{{ formato_numero(dataItem.row.BeneficioTiempo) }}%</q-td
    >

    <q-td
      key="ImporteOfertado"
      class="list_titulo_listado_presupuestos"
      :props="dataItem"
      v-show="isAdmin()"
      style="text-align: center"
      >{{ cleanOfertado }}</q-td
    >

    <q-td
      key="AceptaGdpr"
      class="list_titulo_listado_presupuestos"
      :props="dataItem"
      style="text-align: center"
      >{{ dataItem.row.AceptaGdpr ? "Si" : "No" }}</q-td
    >

    <q-td
      key="AvisosComerciales"
      class="list_titulo_listado_presupuestos"
      :props="dataItem"
      style="text-align: center"
      >{{ dataItem.row.AvisoComercial ? "Si" : "No" }}</q-td
    >

    <q-td>
      <q-chip
        clickable
        dense
        :key="dataItem.row.Id"
        @click.stop="ver_comparativa(dataItem.row.Id)"
        v-show="mostrar_btn_comparativa(dataItem.row.Estado)"
        color="primary"
        text-color="white"
        icon="search"
      >
        <q-tooltip>ver datos comparativa</q-tooltip>
      </q-chip>
    </q-td>

    <q-td>
      <q-chip
        clickable
        dense
        :key="dataItem.row.Id"
        @click.stop="ver_pdf(dataItem.row.Id)"
        color="primary"
        text-color="white"
        icon="get_app"
      >
        <q-tooltip>Ver informe</q-tooltip>
      </q-chip>
    </q-td>
    <q-td>
      <q-chip
        clickable
        dense
        :key="dataItem.row.Id"
        @click.stop="eliminar(dataItem.row.Id, dataItem.row.Nombre)"
        v-show="mostrar_btn_eliminar(dataItem.row.Estado)"
        color="primary"
        text-color="white"
        icon="clear"
      >
        <q-tooltip>eliminar presupuesto</q-tooltip>
      </q-chip>
    </q-td>
  </q-tr>
</template>
<script type="text/javascript">
import { QTooltip, QTd, QTr, QIcon } from 'quasar';
import '@/components/Listados/assets/css_listado_vue.css';

export default {
  props: ['dataItem', 'isDirector'],
  computed: {
    cleanOfertado () {
      let precioOfertado = this.dataItem.row.PrecioOfertado;

      if (precioOfertado == null) {
        return '-';
      } else {
        return this.formato_numero(precioOfertado) + '€';
      }
    },
    sliceActuacion () {
      let variable = this.dataItem.row.Nombre;
      let response = '';
      if (variable.length > 25) {
        response = this.dataItem.row.Nombre.slice(0, 23);
        response += '...';
      } else {
        response = variable;
      }

      return response;
    },
    sliceEmpresa () {
      let variable = this.dataItem.row.Empresa;
      let response = '';
      if (variable.length > 20) {
        response = this.dataItem.row.Empresa.slice(0, 18);
        response += '...';
      } else {
        response = variable;
      }
      return this.primera_mayuscula(response);
    },
    sliceProvincia () {
      let variable = this.dataItem.row.Provincia;
      let response = '';
      if (variable.length > 20) {
        response = this.dataItem.row.Provincia.slice(0, 18);
        response += '...';
      } else {
        response = variable;
      }

      return response;
    },
    sliceMunicipio () {
      let variable = this.dataItem.row.Municipio;
      let response = '';
      if (variable.length > 15) {
        response = this.dataItem.row.Municipio.slice(0, 12);
        response += '...';
      } else {
        response = variable;
      }

      return response;
    }
  },

  filters: {
    formato_fecha (value) {
      var mes = value.substr(5, 2);
      var dia = value.substr(8, 2);
      var anyo = value.substr(0, 4);
      var fecha = dia + '/' + mes + '/' + anyo;

      return fecha;
    }
  },

  methods: {
    primera_mayuscula (cadena) {
      let primer_caracter = cadena.slice(0, 1);
      let resto_carecteres = cadena.slice(1);

      return primer_caracter.toUpperCase() + resto_carecteres.toLowerCase();
    },
    formato_numero (value) {
      if (value == null || value == 0) {
        value = 0;
        return value.toFixed(2).replace('.', ',');
      } else {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },

    cambiar_color (estado) {
      switch (estado) {
        case 'Revisado':
          return '` font-size: 14px;font-weight: bold; color:orange;!important;`';
          break;
        case 'Pendiente datos':
          return '` font-size: 14px;font-weight: bold; color:red;!important;`';
          break;
        case 'Ofertado':
          return '` font-size: 14px;font-weight: bold; color:green;!important;`';
          break;
        case 'Pendiente revisar':
          return '` font-size: 14px;font-weight: bold; color:gray;!important;`';
          break;
      }
    },
    mostrar_btn_comparativa (estado) {
      if (estado != 'Pendiente datos') return true;
      else return false;
    },
    ver_comparativa (id) {
      this.$store.commit('TSZ/setIdComparativa', id);

      this.$router.push({
        name: 'Comparativa',
        path: '/Comparativa',
        component: () =>
          import('@/components/Comparativa/views/TSZ_Comparativas.vue'),
        params: { PresupuestoId: id }
      });
    },
    ver_pdf (id_presupuesto) {
      let pdf_base64 = '';
      let filename = this.dataItem.row.Nombre + '.pdf';

      let request = {
        controller: '/Presupuestos/' + id_presupuesto + '/Informe',
        filter: {},
        data: {
          email: this.$store.getters['TSZ/userMail']
        }
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ_Listado_PDF', request)
        .then((response) => {
          pdf_base64 = response.data.Data.Base64;
          const link = document.createElement('a');
          link.href = 'data:application/pdf;base64,' + pdf_base64;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.showError(err);
          this.isLoadingDatos = false;
        });
    },
    isAdmin () {
      if (this.$store.getters['TSZ/rolAplicacion'] == 2) {
        return true;
      } else if (this.isDirector) {
        return true;
      } else {
        return false;
      }
    },
    eliminar (id, nombre) {
      this.mostrar_mensaje_confirmacion(
        "Se va a eliminar definitivamente el presupuesto: '" +
          nombre +
          "' ¿Está seguro de eliminarlo?",
        id
      );
    },

    mostrar_mensaje_confirmacion (mensaje, id, color, timeout = 3000) {
      this.showErrorActions(mensaje, id, 'red', timeout);
    },

    mostrar_mensaje (mensaje, color, timeout = 5000) {
      this.showError(mensaje, color, timeout);
    },

    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    },

    showErrorActions (text, id, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        multiLine: true,
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [
          {
            label: 'ACEPTAR',
            color: 'white',
            handler: () => {
              this.eliminar_presupuesto(id);
            }
          },
          { label: 'CANCELAR', color: 'white', closeBtn: true }
        ]
      });
    },
    eliminar_presupuesto (id) {
      let request = {
        controller:
          '/Presupuestos/' +
          id +
          '/Delete?email=' +
          this.$store.getters['TSZ/userMail']
      };
      this.$store
        .dispatch('TSZ/deletePresupuesto', request)
        .then((response) => {
          this.mostrar_mensaje('Presupuesto eliminado correctamente', 'green');
          this.$emit('delete-row');
        })
        .catch((err) => {
          this.mostrar_mensaje(
            'Se ha producido un error al eliminar el presupuesto: ' + err,
            'red'
          );
        });
    },
    mostrar_btn_eliminar (estado) {
      if (this.esAministrador()) return true;
      else {
        if (estado == 'Pendiente datos') return true;
        else return false;
      }
    },
    esAministrador () {
      if (this.$store.getters['TSZ/rolAplicacion'] == 2) return true;
      else return false;
    }
  },

  components: {
    QTooltip,
    QTd,
    QTr,
    QIcon
  }
};
</script>
<style lang="scss" scoped>
.row-presupuesto {
  &::v-deep {
    .q-chip--dense .q-chip__icon--left {
      margin-right: 0px;
    }
  }
}
@media (max-width: 1280px) {
  .list_titulo_listado_presupuestos_estado {
    font-size: 11px !important;
  }
  .list_titulo_listado_presupuestos {
    font-size: 11px !important;
  }
  .list_titulo_listado_presupuestos_negrita {
    font-size: 11px !important;
  }
}
</style>
